/**
 * @generated SignedSource<<b91287ae8d1d8e6e4e7669215a3c7c3d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type PROJECT_STATUS = "OPPORTUNITY" | "PLANNING" | "RUNNING" | "HALTED" | "DONE" | "%future added value";
export type CreateProjectStageInput = {
  name: string;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type CreateProjectStageMutation$variables = {
  input: CreateProjectStageInput;
};
export type CreateProjectStageMutation$data = {
  readonly createProjectStage: {
    readonly projectStageEdge: {
      readonly node: {
        readonly id: string;
        readonly name: string | null;
        readonly sortOrder: number | null;
        readonly profile: PROJECT_STATUS | null;
      } | null;
    } | null;
  } | null;
};
export type CreateProjectStageMutation = {
  variables: CreateProjectStageMutation$variables;
  response: CreateProjectStageMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sortOrder",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "profile",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CreateProjectStageMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CreateProjectStagePayload",
        "kind": "LinkedField",
        "name": "createProjectStage",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ProjectStageTypeEdge",
            "kind": "LinkedField",
            "name": "projectStageEdge",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CreateProjectStageMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CreateProjectStagePayload",
        "kind": "LinkedField",
        "name": "createProjectStage",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ProjectStageTypeEdge",
            "kind": "LinkedField",
            "name": "projectStageEdge",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  },
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "529fc6047610c2fa744b6bda8140b8d8",
    "id": null,
    "metadata": {},
    "name": "CreateProjectStageMutation",
    "operationKind": "mutation",
    "text": "mutation CreateProjectStageMutation(\n  $input: CreateProjectStageInput!\n) {\n  createProjectStage(input: $input) {\n    projectStageEdge {\n      node {\n        __typename\n        id\n        name\n        sortOrder\n        profile\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "f965e70c3ff7130408de13cb27dfdf4e";

export default node;
